import utils from '../../utils'

class DirectiveTouch {
  constructor (el, binding) {
    this.$el = el
    this.binding = binding
    this.params = binding.value.params
    this.touches = {
      x: 0,
      y: 0
    }
    this.offset = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }
    this.isMove = false
    this.isStart = false
    this.isEnd = false
    this.isLong = false
    this.startFn = typeof binding.value === 'object' && typeof binding.value.start === 'function'
      ? binding.value.start : null
    this.endFn = typeof binding.value === 'object' && typeof binding.value.end === 'function'
      ? binding.value.end : null
    this.callback = typeof binding.value === 'object' && typeof binding.value.fn === 'function'
      ? binding.value.fn : null
    this.leftFn = typeof binding.value === 'object' && typeof binding.value.left === 'function'
      ? binding.value.left : null
    this.rightFn = typeof binding.value === 'object' && typeof binding.value.right === 'function'
      ? binding.value.right : null
    this.upFn = typeof binding.value === 'object' && typeof binding.value.up === 'function'
      ? binding.value.up : null
    this.downFn = typeof binding.value === 'object' && typeof binding.value.down === 'function'
      ? binding.value.down : null
    this.tapFn = typeof binding.value === 'object' && typeof binding.value.tap === 'function'
      ? binding.value.tap : null
    this.longTapFn = typeof binding.value === 'object' && typeof binding.value.longTap === 'function'
      ? binding.value.longTap : null
  }

  bind () {
    this.$el.addEventListener('touchstart', (event) => {
      this.handleStart(event)
    }, false)

    this.$el.addEventListener('touchmove', (event) => {
      this.handleMove(event)
    }, false)

    this.$el.addEventListener('touchend', (event) => {
      this.handleEnd(event)
    }, false)
  }

  update (params) {
    this.params = params
  }

  handleStart (event) {
    event.preventDefault()

    const pageX = event.changedTouches[0].pageX
    const pageY = event.changedTouches[0].pageY
    const flag = this.startFn && this.startFn(this.$el, this.params, {
      x: pageX | 0,
      y: pageY | 0
    }, event)

    if (flag === false) {
      return
    }

    const offset = utils.offset(this.$el)

    this.offset = offset
    this.isMove = false
    this.isStart = true
    this.isEnd = false
    this.isLong = true
    this.touches = {
      x: pageX,
      y: pageY
    }

    this.delay = setTimeout(() => {
      if (!this.isEnd && !this.isMove) {
        this.isStart = false
        this.isEnd = true
        this.longTapFn && this.longTapFn(this.$el, this.params, event)
      }
    }, 1000)
  }

  handleMove (event) {
    if (!this.isStart) {
      return
    }

    this.isMove = true

    const pageX = event.changedTouches[0].pageX
    const pageY = event.changedTouches[0].pageY

    if (this.callback) {
      this.callback(this.$el, this.params, {
        x: pageX,
        y: pageY,
        mx: (pageX - this.touches.x) | 0,
        my: (pageY - this.touches.y) | 0
      }, event)
    }

    if (
      pageX < this.offset.left ||
      pageX > this.offset.right ||
      pageY < this.offset.top ||
      pageY > this.offset.bottom
    ) {
      this.handleEnd(event)
    }
  }

  handleEnd (event) {
    clearTimeout(this.delay)

    const pageX = event.changedTouches[0].pageX
    const pageY = event.changedTouches[0].pageY
    const pos = {
      x: pageX | 0,
      y: pageY | 0,
      mx: pageX - this.touches.x,
      my: pageY - this.touches.y
    }

    this.endFn && this.endFn(this.$el, this.params, pos, event)

    if (this.isEnd) {
      return false
    }
    this.isStart = false
    this.isEnd = true

    if (Math.abs(pos.mx) > 10 || Math.abs(pos.my) > 10) {
      if (Math.abs(pos.mx) > Math.abs(pos.my)) {
        if (pos.mx > 10) {
          this.rightFn && this.rightFn(this.$el, this.params, pos, event)
        }

        if (pos.mx < -10) {
          this.leftFn && this.leftFn(this.$el, this.params, pos, event)
        }
      } else {
        if (pos.my > 10) {
          this.downFn && this.downFn(this.$el, this.params, pos, event)
        }

        if (pos.my < -10) {
          this.upFn && this.upFn(this.$el, this.params, pos, event)
        }
      }
    } else {
      this.tapFn && this.tapFn(this.$el, this.params, pos, event)
    }
  }
}

export default DirectiveTouch
